export default "/assets/images/mila-square-new.a4aabde123d8ff36.webp";